<template>
  <div class="no-padding">
    <label v-if="editable" class="editable-header" @click="$emit('edit_clicked', 'header', 0)" v-html="header_html"></label>
    <label v-else class="question-label">{{ item.header || item.name }}</label>

    <div class="points-options">
      <!-- Create buttons based on num_options -->
      <button 
        v-for="(option, index) in item.num_options" 
        :key="index" 
        class="point-button"
        :class="{'selected': selected.includes(index + 1)}"
        @click="toggleSelection(index + 1)"
      >
        {{ index + 1 }}
      </button>
    </div>

    <!-- Conditional text input based on selected option -->
    <div v-if="show_text">
      <label for="input-text">Please provide additional details:</label>
      <input 
        v-model="input_text" 
        type="text" 
        id="input-text" 
        class="text-input"
        placeholder="Enter text"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionPointsOption',
  props: ['item', 'editable'],
  emits: ['option_update', 'selected', 'edit_clicked'],
  data() {
    return {
      selected: [],
      show_text: false,
      input_text: null,
    };
  },
  computed: {
    header_html() {
      return this.item.header || this.item.name;
    }
  },
  watch: {
    item: {
      deep: true,
      handler() {
        this.selected = [];
      }
    },
    input_text: {
      deep: true,
      handler() {
        if (this.input_text) {
          this.$emit('selected', this.selected, this.input_text);
        }
      }
    },
    selected: {
      deep: true,
      handler() {
        this.$emit('selected', this.selected, this.input_text);
        const unlock_text = this.item.options.find(i => i.unlock_text);
        this.show_text = !!unlock_text && this.selected.length > 0;
      }
    }
  },
  methods: {
    option_edit_clicked(part, index) {
      this.$emit('edit_clicked', 'question_text', index);
    },
    text_updated(option, value) {
      this.$emit('option_update', option, value);
    },
    toggleSelection(value) {
      // Toggle selection logic
      if (this.selected.includes(value)) {
        this.selected = this.selected.filter(v => v !== value);
      } else {
        this.selected = [value]; // Only one selection allowed
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.question-label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
.points-options {
  display: flex;
  gap: 10px;
  width: 100%; /* Ensure it takes up the full available width */
}

.point-button {
  flex: 1; /* This ensures each button takes up equal space */
  padding: 10px 0; /* Vertical padding for consistent height */
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center; /* Center the number inside the button */
  font-size: 1.2em; /* Ensures text is centered and proportional */
}

.point-button.selected {
  background-color: #0085eb;
  color: white;
  border-color: #0085eb;
}

.point-button:hover {
  background-color: #e0e0e0;
}

.text-input {
  padding: 8px;
  width: 100%;
  margin-top: 10px;
}

.editable-header {
  min-width: 300px;
  min-height: 20px;
  padding: 8px;
}

.editable-header:hover {
  border: 2px solid rgb(50, 201, 50);
}
</style>
